import { render } from "./match-details.vue?vue&type=template&id=c11cb146&scoped=true&ts=true"
import script from "./match-details.vue?vue&type=script&lang=ts"
export * from "./match-details.vue?vue&type=script&lang=ts"

import "./match-details.vue?vue&type=style&index=0&id=c11cb146&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c11cb146"]])

export default __exports__